<template>
  <div 
    :class="{'is-active' : active}"
    class="modal"
  >
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <p class="is-size-4"
           style="margin-bottom: 20px"
        >
          Cambio della password
        </p>

        <div class="field">
          <label class="label">Vecchia password</label>
          <div class="control">
            <input
              v-model="oldPassw"
              class="input"
              type="password"
            />
          </div>
        </div>
        <div class="field">
          <label class="label">Nuova password</label>
          <div class="control">
            <input
              v-model="newPassw"
              class="input"
              type="password"
            />
          </div>
        </div>
        <div class="field" style="margin-bottom: 20px">
          <label class="label">Ripeti nuova password</label>
          <div class="control">
            <input
              v-model="repeatNewPassw"
              class="input"
              type="password"
            />
          </div>
        </div>
        <div class="field is-grouped is-grouped-right">
          <div class="control">
            <button 
              :class="{ 'is-loading' : isLoading }" 
              class="button is-info"
              @click="onSaveClick"
            >
              Salva
            </button>
          </div>
          <div class="control">
            <button class="button is-light" @click="$emit('cancel')">
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	name: "ChangeUserPasswModal",
	props: {
		active: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			oldPassw: "",
			newPassw: "",
			repeatNewPassw: "",
      isLoading: false
		}
	},
	methods: {
		onSaveClick() {
      if(this.oldPassw.trim() === "" || this.newPassw.trim() === "" || this.repeatNewPassw.trim() === "") { 
        this.$_notify({
          text: "Compila tutti i campi",
          type: 'warning'
        })
        return
      }

      this.isLoading = true
      this.$api
        .user
        .updatePassword(this.newPassw, this.repeatNewPassw)
        .then(() => {
          this.$emit('confirm')
          this.$_notify({
            text: "Password aggiornata con successo",
            type: 'success'
          })
        })
        .catch(() => {
          this.$_notify({
            text: "Qualcosa è andato storto, riprovare",
            type: 'danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
		}
	}
}
</script>